
export default () => {
    // $(".custom-select").each(function() {
    //     let classes = $(this).attr("class"),
    //         id      = $(this).attr("id"),
    //         name    = $(this).attr("name");
    //     let template =  '<div class="' + classes + '">';
    //
    //     template += '<span class="custom-select-trigger">' + $(this).find("option:selected").text() + '</span>';
    //     template += '<div class="custom-options">';
    //     template += '<div class="options-wrap">';
    //
    //     $(this).find("option").each(function() {
    //         template += '<span class="custom-option ' + $(this).attr("selected") + '" data-value="' + $(this).attr("value")  + '">' + $(this).html() +   '</span>';
    //     });
    //     $(this).find("label").each(function() {
    //         template += '<span class="custom-label ' + $(this).html() +   '</span>';
    //     });
    //     template += '</div></div>';
    //     $(this).hide();
    //     $(this).before(template);
    // });

    // $(".custom-option:first-of-type").hover(function() {
    //     $(this).parents(".custom-options").addClass("option-hover");
    // }, function() {
    //     $(this).parents(".custom-options").removeClass("option-hover");
    // });
    //
    $('.custom-select').on("click", '.custom-select-trigger', function() {
        const parent = $(this).parent('.custom-select')
        parent.toggleClass("opened");
        event.stopPropagation();
    });

    $(".custom-option").on("click", function() {
        const parentSelect = $(this).parents(".custom-select")
        const optionValueAttr = $(this).attr('data-value')

        const select = parentSelect.next()
        select.val(optionValueAttr)
        select.trigger('change', select )

        $(this).parents(".custom-options").find(".custom-option").removeClass("selected");
        $(this).addClass("selected");
        parentSelect.removeClass("opened");
        parentSelect.find(".custom-select-trigger").text($(this).text());
    });

    $('body').click(function (event) {
        event.stopPropagation()
        if (!$(event.target).closest('.custom-select').length){
            $('.custom-select').removeClass('opened')
            return
        }
    });

}
